import { render } from "./NewEvent.vue?vue&type=template&id=1fb91634&scoped=true"
import script from "./NewEvent.vue?vue&type=script&lang=js"
export * from "./NewEvent.vue?vue&type=script&lang=js"

import "./NewEvent.vue?vue&type=style&index=0&id=1fb91634&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb91634"]])

export default __exports__